import clamp from "./clamp.js";
function clamp01(value) {
  return clamp(value, 0, 1);
}
export {
  clamp01 as default
};
//# sourceMappingURL=clamp01.js.map
